import React from "react";
import { useParams } from "react-router";
import styled from "styled-components";

import { WorkspacePickerPage } from "../components/auth/WorkspacePickerPage";
import { OnboardingContainer } from "../components/login/OnboardingElements";

import { WorkspacePickerType, useQueryParams } from "./routes";

export const PickerContainer = styled(OnboardingContainer)`
  display: flex;
  height: 100%;
  width: 100%;

  flex-direction: column;
  align-items: center;

  overflow-y: auto;
`;

interface WorkspacePickerRouteParams extends Record<
  string,
  string | undefined
> {
  subView: WorkspacePickerType;
}

export const WorkspacePickerRoute: React.ComponentType = React.memo(
  function WorkspacePickerRoute() {
    const queryParams = useQueryParams();
    const subView = useParams<WorkspacePickerRouteParams>().subView;

    // TODO(VELO-4838): Replace this
    const email = queryParams.get("email") ?? undefined;

    return (
      <PickerContainer logoProps={{ linkEnabled: false }}>
        {(subView === "signup" || subView === "signUp") && (
          <WorkspacePickerPage email={email} isSignup={true} />
        )}
        {subView === "login" && (
          <WorkspacePickerPage email={email} isSignup={false} />
        )}
      </PickerContainer>
    );
  },
);

export default WorkspacePickerRoute;
